export default __webpack_public_path__ + "static/media/0xa6b37fc85d870711c56fbcb8afe2f8db049ae774.5b107d66.webp";